module.exports = __webpack_public_path__ + "img/answer-img2.ed7f425e.png";